import React, { useEffect } from "react";
import { CssBaseline, Box } from "@mui/material";

// import Sidebar from "../components/shared/sidebar";
// import Header from "../components/shared/header";
// import Dashboard from "../components/shared/dashboard/dashboard";
import MainDetails from "../components/profile/maindetails";
import MetaDecorator from "../services/meta_decorator";
import Newsidebar from "../components/shared/newsidebar";
import Newheader from "../components/shared/newheader";
import { bodyBg2, fullHeight } from "../style2";

function Professional_Profile() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box sx={{...fullHeight, ...bodyBg2}}>
      <CssBaseline />
      <MetaDecorator title={"EnrichMyCare - Professional Profile"} description={"Professional dashboard app"} />
      <Newsidebar selected='home' />
      <Newheader show_welcome_message={false} show_back_button={true} show_profile_button={false}/>
      {/* <Box mt={12} /> */}
      <MainDetails />
    </Box>
  );
}

export default Professional_Profile;
